<script>
export default {
  name: 'view-custom-seat',
  props: {
    value: { type: Object, default: () => {} }
  },
  data () {
    return {
      specs: {
        model_type: null,
        foam_type: null,
        seat_width: null,
        seat_depth: null
      }
    }
  },
  watch: {
    value: {
      handler (v) {
        if (v) this.specs = { ...v }
      },
      immediate: true
    }
  }
}
</script>
<template>
  <b-row no-gutters align-v="start" align-h="center">
    <b-col align-self="start">
      <h6 class="mt-4">{{ $t('specifications') }}</h6>
      <p class="p-0 my-2 mb-2">
        <i class="text-muted mr-2">{{ $t(`attribute.model_type.key`) }}: </i>
        {{
          $t(`attribute.model_type.value`, {
            value: $t(`attribute.model_type.${specs.model_type}`)
          })
        }}
      </p>

      <p class="p-0 my-2 mb-2">
        <i class="text-muted mr-2">{{ $t(`attribute.foam_type.key`) }}: </i>
        {{
          $t(`attribute.foam_type.value`, {
            value: $t(`attribute.foam_type.${specs.foam_type}`)
          })
        }}
      </p>

      <p class="p-0 m-0 mb-2">
        <i class="text-muted mr-2">{{ $t(`attribute.seat_width.key`) }}: </i>
        {{
          $t(`attribute.seat_width.value`, {
            value: specs.seat_width
          })
        }}
      </p>

      <p class="p-0 m-0 mb-2">
        <i class="text-muted mr-2">{{ $t(`attribute.seat_depth.key`) }}: </i>
        {{
          $t(`attribute.seat_depth.value`, {
            value: specs.seat_depth
          })
        }}
      </p>
    </b-col>
  </b-row>
</template>
